import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useUIStore = defineStore('modal', () => {
  // Mobiele weergave-toggle (admin ↔ monteur). Gedeeld zodat naast de
  // Sidebar ook pagina's (zoals WorkOrderDetailPage) weten dat een admin
  // in monteursweergave zit. Persistent in localStorage zodat de keuze
  // een page reload / nieuw tabblad overleeft.
  const INSTALLER_MODE_STORAGE_KEY = 'sf_mobile_installer_mode';

  const readStoredInstallerMode = () => {
    try {
      return localStorage.getItem(INSTALLER_MODE_STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  };

  const mobileInstallerMode = ref(readStoredInstallerMode());

  const setMobileInstallerMode = (value) => {
    mobileInstallerMode.value = value;
    try {
      localStorage.setItem(INSTALLER_MODE_STORAGE_KEY, value ? '1' : '0');
    } catch {
      // Storage niet beschikbaar (bijv. private mode) — alleen in-memory.
    }
  };

  const modals = ref([]);
  const drawer = ref({
    isOpen: false,
    component: null,
    props: {},
  });

  const addModal = (component, props = {}, onClose = null) => {
    const id = Date.now();
    modals.value.push({ id, component, props, onClose, show: true });
    return id;
  };

  const removeModal = (id) => {
    modals.value = modals.value.filter((modal) => modal.id !== id);
  };

  const closeModal = (id) => {
    const modal = modals.value.find((modal) => modal.id === id);
    if (modal) {
      modal.show = false;
      setTimeout(() => {
        removeModal(id);
      }, 300); // Match this to the transition duration
    }
  };

  const updateModalProps = (id, newProps) => {
    const modal = modals.value.find((modal) => modal.id === id);
    if (modal) {
      modal.props = { ...modal.props, ...newProps };
    }
  };

  const addError = (title, description) => {
    const id = Date.now();
    modals.value.push({
      id,
      component: null,
      props: {
        type: 'error',
        title,
        description,
      },
      show: true,
    });
    return id;
  };

  const openDrawer = (component, props = {}) => {
    drawer.value = {
      isOpen: true,
      component,
      props,
    };
  };

  const closeDrawer = () => {
    drawer.value.isOpen = false;
    setTimeout(() => {
      drawer.value.component = null;
      drawer.value.props = {};
    }, 300); // Match transition duration
  };

  const closeAllModals = () => {
    // Close all modals
    modals.value.forEach((modal) => {
      modal.show = false;
    });
    // Remove all modals after transition
    setTimeout(() => {
      modals.value = [];
    }, 300); // Match transition duration
  };

  return {
    mobileInstallerMode,
    setMobileInstallerMode,
    modals,
    addModal,
    removeModal,
    closeModal,
    closeAllModals,
    updateModalProps,
    addError,
    drawer,
    openDrawer,
    closeDrawer,
  };
});
